import { render, staticRenderFns } from "./label-item.vue?vue&type=template&id=668cbee6&scoped=true"
import script from "./label-item.vue?vue&type=script&lang=ts"
export * from "./label-item.vue?vue&type=script&lang=ts"
import style0 from "./label-item.vue?vue&type=style&index=0&id=668cbee6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668cbee6",
  null
  
)

export default component.exports